import { bitmapAdapterExtensions } from "./bitmap/bitmap-adapter-extensions"
import { rawAdapterExtensions } from "./raw/raw-adapter-extensions"

export const allSupportedExtensions = [...bitmapAdapterExtensions, ...rawAdapterExtensions]
